import styled from 'styled-components'

export const HelpWrapper = styled.span`
  line-height: 0;
  pointer-events: all !important;

  i.icon {
    font-size: 16px !important;
    margin: 0 !important;
    top: 2px;
  }
`

export const LabelWrapper = styled.div`
  cursor: pointer;

  :hover {
    color: initial;
  }

  i.icon {
    top: 4px;
    margin-left: 0.25em !important;
    margin-right: 0 !important;
  }
`
